import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { Dashboard } from '@/pages/Dashboard';
import { Sessions } from '@/pages/Sessions';
import { Chat } from '@/pages/Chat';
import { Skills } from '@/pages/Skills';
import { Memory } from '@/pages/Memory';
import { Settings } from '@/pages/Settings';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="chat/:sessionId?" element={<Chat />} />
        <Route path="skills" element={<Skills />} />
        <Route path="memory/:sessionId?" element={<Memory />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}